// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__383hR","list_item":"styles_list_item__1rvhh","more":"styles_more__3RGDj"};